const {KitModule, registerModule} = window;

class Photography extends KitModule {
  constructor($element) {
    super($element);
    this.initialize();
  }

  initialize() {
    this.setVars();
    this.setRootVars();
  }

  setVars() {
    this.$previous = this.$element.previousElementSibling;
    this.previousClassNames = this.$previous.className;
    this.previousHasThemeClass = this.previousClassNames.includes('theme');

    this.$next = this.$element.nextElementSibling;
    this.nextClassNames = this.$next.className;
    this.nextHasThemeClass = this.nextClassNames.includes('theme');

    if (this.nextHasThemeClass) {
      this.nextIsDark = this.$next.classList.contains('theme-dark');
    }

    if (this.previousHasThemeClass) {
      this.previousIsDark = this.$previous.classList.contains('theme-dark');
    }
  }

  setRootVars() {
    if ((this.nextIsDark && !this.previousIsDark) || (!this.nextIsDark && this.previousIsDark)) {
      this.$element.setAttribute('style', '--stripe-color: var(--color-dark)');
      if (this.nextIsDark) this.$element.classList.add('gallery--stripe-bottom');
      if (this.previousIsDark) this.$element.classList.add('gallery--stripe-top');
    } else if (this.nextIsDark && this.previousIsDark) {
      this.$element.classList.remove('theme-light');
      this.$element.classList.add('theme-dark');
      this.$element.removeAttribute('style');
    } else {
      this.$element.setAttribute('style', '--stripe-color: var(--color-light)');
    }
  }
}

registerModule('Photography', Photography);
